import classNames from 'classnames';

import Typography from 'components/Typography';
import Spacer from 'components/Spacer';
import classes from 'styles/pages/Attorneys/Summary.module.scss';

import Paper from './Paper';

const Summary = () => (
  <div className={classes.root}>
    <div className={classes.wrapper}>
      <Paper className={classNames(classes.iconBox, classes.organizations)}>
        <div className={classes.gradient} />
        <div className={classes.text}>
          <Typography variant="h1" unsetColor>
            3,000
          </Typography>
          <Typography variant="h3">Organizations</Typography>
        </div>
      </Paper>

      <Paper className={classNames(classes.iconBox, classes.members)}>
        <div className={classes.gradient} />
        <div className={classes.text}>
          <Typography variant="h1" unsetColor>
            5,000,000
          </Typography>
          <Typography variant="h3">Members</Typography>
        </div>
      </Paper>
    </div>

    <div className={classes.summaryBox}>
      <div className={classes.innerBox}>
        <Typography variant="h2" unsetColor>
          Who You'll Work With
        </Typography>

        <Spacer v={18} />

        <Typography>
          As part of the network, you’ll work with the employees of companies ranging from Fortune
          500 to small businesses on a range of common legal issues.
        </Typography>
      </div>
      <div className={classes.backgroundBox}>
        <Paper colorful>
          <div className={classes.fillerBox} />
        </Paper>
      </div>
    </div>

    <Paper colorful className={classes.mobilePaper}>
      <div className={classes.mobileTextbox}>
        <Typography variant="h2" unsetColor>
          Who You'll Work With
        </Typography>

        <Spacer v={18} />

        <Typography>
          As part of the network, you’ll work with the employees of companies ranging from Fortune
          500 to small businesses on a range of common legal issues.
        </Typography>
      </div>
    </Paper>
  </div>
);

export default Summary;
